export class User {

      public id: number;
      public nom: string;
      public prenom: string;
      public password: string;
      public fonctionWellD : string; //La superbe fonction que occupe le collaborateur ou Ancien collaborateur
      public email: string;
      public telephone : string;
      public rolee : string;
      public isActive: boolean;
      public roles : [ {role : string;}];
      public maintenace : boolean;
      
      constructor() { }
    }



// WEBPACK FOOTER //
// ./src/app/entities/user.ts